import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";
import { ConceptTemplate, ScreenTemplate } from "app/common/Model/ScreenTemplate";
import { deleteScreenTemplate, getScreenTemplateById, pagingScreenTemplate, saveOrUpdateByStaffAndScreen, saveOrUpdate, searchItemByPage, saveConceptTemplate, getConceptTemplateById, markDeleteConceptTemplate } from "app/services/ScreenTemplateService";

export default class ScreenTemplateStore {
    listScreenTemplateByStaffAndScreen = [];
    searchScreenTemplate = new SearchObject();
    searchScreenTemplateByStaff = new SearchObject();
    pageScreenTemplate = null;
    selectedScreenTemplate = {};
    selectedScreenTemplateByStaff = {};
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    saveOrUpdateByStaffAndScreen = async (obj) => {
        return await saveOrUpdateByStaffAndScreen(obj)
            .then(({ data }) => {
                // this.listScreenTemplateByStaffAndScreen = data;
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi", "Thông báo");
            })
    }

    searchItemByPage = async () => {
        let obj = { ...this.searchScreenTemplateByStaff, staffId: this.searchScreenTemplateByStaff?.staffId?.id }
        return await searchItemByPage(obj)
            .then(({ data }) => {
                this.listScreenTemplateByStaffAndScreen = data;
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi", "Thông báo");
            })
    }

    pagingScreenTemplate = async () => {
        return await pagingScreenTemplate(this.searchScreenTemplate)
            .then(({ data }) => {
                this.pageScreenTemplate = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi", "Thông báo")
            })
    }

    handleChangeFormSearch = (searchScreenTemplate) => {
        this.searchScreenTemplate = checkSearchObject(this.searchScreenTemplate, searchScreenTemplate);
        this.pagingScreenTemplate();
    }

    handleChangeFormSearchByScreen = (obj) => {
        this.searchScreenTemplateByStaff = { ...this.searchScreenTemplateByStaff, ...obj }
        this.searchItemByPage();
    }

    handleOpenFormCreateOrEdit = (ScreenTemplateId) => {
        if (Boolean(ScreenTemplateId)) {
            getScreenTemplateById(ScreenTemplateId).then(({ data }) => {
                this.selectedScreenTemplate = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedScreenTemplate = new ScreenTemplate();
            this.openFormCreateOrEdit = true;
        }
    }

    handleOpenFormCreateOrEditScreen = (ScreenTemplateId) => {
        if (Boolean(ScreenTemplateId)) {
            getConceptTemplateById(ScreenTemplateId).then(({ data }) => {
                this.selectedScreenTemplateByStaff = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedScreenTemplateByStaff = new ConceptTemplate();
            this.openFormCreateOrEdit = true;
        }
    }

    saveConceptTemplate = (ScreenTemplate, { setSubmitting }) => {
        saveConceptTemplate(ScreenTemplate)
            .then(() => {
                this.selectedScreenTemplateByStaff = null;
                toast.success("Lưu dữ liệu thành công!");
                this.searchItemByPage();
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    saveOrUpdateScreenTemplate = (ScreenTemplate, { setSubmitting }) => {
        saveOrUpdate(ScreenTemplate)
            .then(() => {
                this.selectedScreenTemplate = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingScreenTemplate();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (ScreenTemplate) => {
        this.selectedScreenTemplate = { id: ScreenTemplate?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteScreenTemplate(this.selectedScreenTemplate?.id)
            .then(() => {
                if (this.searchScreenTemplate?.pageIndex > 1 && this.pageScreenTemplate?.content?.length === 1) {
                    this.searchScreenTemplate.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingScreenTemplate();
                this.searchItemByPage();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi", "Thông báo");
            })
    }

    handleDeleteScreen = (ScreenTemplate) => {
        this.selectedScreenTemplateByStaff = { id: ScreenTemplate?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDeleteScreen = async () => {
        return await markDeleteConceptTemplate(this.selectedScreenTemplateByStaff?.id)
            .then(() => {
                if (this.searchScreenTemplateByStaff?.pageIndex > 1 && this.listScreenTemplateByStaffAndScreen?.content?.length === 1) {
                    this.searchScreenTemplateByStaff.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.searchItemByPage();
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi", "Thông báo");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }


    //for choosing ScreenTemplate in ChooseScreenTemplatePopup.jsx 
    listScreenTemplate = [];
    ScreenTemplateIdSet = null;

    isValidScreenTemplate = ScreenTemplate => {
        if (ScreenTemplate && ScreenTemplate?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addScreenTemplate = ScreenTemplate => {
        if (!this.isValidScreenTemplate(ScreenTemplate)) return;
        this.listScreenTemplate.push(ScreenTemplate);
        this.ScreenTemplateIdSet.add(ScreenTemplate?.id);
    }

    initializelistScreenTemplate = ScreenTemplates => {
        this.ScreenTemplateIdSet = new Set();
        this.listScreenTemplate = [];
        if (ScreenTemplates && ScreenTemplates?.length > 0) {
            for (let i = 0; i < ScreenTemplates.length; i++) {
                this.addScreenTemplate(ScreenTemplates[i]);
            }
        }
    }

    removeScreenTemplate = ScreenTemplate => {
        if (!this.isValidScreenTemplate(ScreenTemplate)) return;
        if (this.ScreenTemplateIdSet.has(ScreenTemplate?.id)) {
            this.ScreenTemplateIdSet.delete(ScreenTemplate?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = ScreenTemplate => {
        if (!this.isValidScreenTemplate(ScreenTemplate)) return;
        return this.ScreenTemplateIdSet.has(ScreenTemplate?.id);
    }

    getScreenTemplateIdSet = () => {
        return this.ScreenTemplateIdSet;
    }

    getListScreenTemplate = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listScreenTemplate && this.listScreenTemplate?.length > 0) {
            for (let i = 0; i < this.listScreenTemplate.length; i++) {
                const ScreenTemplate = this.listScreenTemplate[i];
                if (this.isExist(ScreenTemplate) && !bufferIdSet.has(ScreenTemplate?.id)) {
                    data.push(ScreenTemplate);
                    bufferIdSet.add(ScreenTemplate?.id);
                }
            }
        }
        this.listScreenTemplate = data;
        return data;
    }

    resetStore = () => {
        this.listScreenTemplateByStaffAndScreen = [];
        this.searchScreenTemplate = new SearchObject();
        this.searchScreenTemplateByStaff = new SearchObject();
        this.pageScreenTemplate = null;
        this.selectedScreenTemplate = {};
        this.selectedScreenTemplateByStaff = {};
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
        this.recentlyUpdated = false;
    }
}
